// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2Eitc","right":"styles_right__1kXya"};